export default {
  title: 'Nebula buds AI Appel', // "Nebula buds AI通话" 翻译为法语
  userID: 'ID de l\'utilisateur : ', // "用户ID : "
  hurryUp: 'En attente de l\'appel de l\'autre partie', // "等待对方呼叫"
  waitingCall: 'En attente de l\'appel de l\'autre partie sur cette page, veuillez ne pas fermer la page prématurément.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Commutateur des sous-titres', // "字幕开关"
  initWait: 'En attente de l\'initialisation', // "等待初始化"
  initSuccess: 'Initialisation terminée, en attente de l\'appel de l\'autre partie. Veuillez ne pas fermer la page !', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Appel connecté', // "电话接通"
  callEnd: 'Appel terminé', // "通话结束"
  careful: 'Attention : ', // "注意 : "
  wait: 'Le composant d\'appel est prêt, en attente de l\'appel de l\'autre partie', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arabe', // "阿拉伯语"
    da: 'Danois', // "丹麦语"
    de: 'Allemand', // "德语"
    en: 'Anglais', // "英语"
    es: 'Espagnol', // "西班牙语"
    fil: 'Filipino', // "菲律宾语"
    fr: 'Français', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonésien', // "印度尼西亚语"
    it: 'Italien', // "意大利语"
    ja: 'Japonais', // "日文"
    ko: 'Coréen', // "韩语"
    ms: 'Malais', // "马来语"
    no: 'Norvégien', // "挪威语"
    pt: 'Portugais', // "葡萄牙语"
    ru: 'Russe', // "俄语"
    sv: 'Suédois', // "瑞典语"
    th: 'Thaïlandais', // "泰语"
    tr: 'Turc', // "土耳其语"
    vi: 'Vietnamien', // "越南语"
    zh: 'Chinois' // "中文"
  }
}
